import styled from 'styled-components';

const colors: Record<string, string> = {
  positive: 'var(--viz-bullish-soft)',
  negative: 'var(--viz-bearish-soft)',
};

export const Rectangle = styled.rect<{ $direction: string }>`
  fill: ${({ $direction }) => colors[$direction]};
  opacity: 1;
  stroke: var(--background-default);
  stroke-width: 1px;
`;

export const SectionAreaWrapper = styled.g`
  width: 100%;
`;
